import get from 'lodash.get';
import { IConfiguredHttp } from './http';

export interface INotificationCreationResult {
	id: string;
	statusCode?: number;
	message?: string;
}

export interface INotificationsApi {
	createNotification: (
		recipient: string,
		content: any,
		notificationType: string,
		notificationChannels: string[],
		deferredUntil: string | null
	) => Promise<INotificationCreationResult>;
}

const notificationsApiFactory = (http: IConfiguredHttp, prefix: string = ''): INotificationsApi => ({
	async createNotification(
		recipient: string,
		content: any,
		notificationType: string,
		notificationChannels: string[],
		deferredUntil: string | null
	) {
		try {
			return await http.post(`${prefix}`, {
				recipient,
				content,
				notification_type: notificationType,
				notification_channels: notificationChannels,
				...(deferredUntil !== null && { deferred_until: deferredUntil })
			});
		} catch (err) {
			return {
				message: get(err, 'response.data.Message', 'Unknown notification creation error'),
				statusCode: get(err, 'response.status', -1),
				id: -1
			};
		}
	}
});

export default notificationsApiFactory;
